import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const ChevronLeft: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.51843 3.26678C9.84917 2.93541 10.3862 2.93587 10.7164 3.26781C11.045 3.59816 11.0444 4.13207 10.7151 4.46169L7.17798 8.00211L10.7143 11.5373C11.044 11.8668 11.0447 12.401 10.716 12.7315C10.386 13.0633 9.84923 13.0639 9.51847 12.7328L5.21048 8.42073C4.9794 8.18943 4.97931 7.81469 5.21027 7.58328L9.51843 3.26678Z"
      fill="currentColor"
    />
  </svg>
);
